import { useParams } from 'react-router-dom';

const NODE_ENV = process.env.NODE_ENV;

function withParams(Component) {
  return (props) => <Component {...props} params={useParams()} />;
}

function log(...params) {
  if (NODE_ENV === "development") {
    if (params.length === 1) {
      console.log(params[0])
    } else {
      console.log(params.join(' '));
    }
  }
}

export { withParams, log };